import React, { useState } from 'react';
import { TextField, Button, Typography, Container, Link, Alert, Paper, Box } from '@mui/material';
import { login } from '../api/auth';
import { useNavigate, Link as RouterLink } from 'react-router-dom';

const Login: React.FC<{ setIsLoggedIn: (value: boolean) => void, setUserName: (name: string) => void }> = ({ setIsLoggedIn, setUserName }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    try {
      const data = await login(email, password);
      if (data.token) {
        localStorage.setItem('token', data.token);
        localStorage.setItem('userName', data.name);
        setIsLoggedIn(true);
        setUserName(data.name);
        navigate('/dashboard');
      } else {
        setError('Login failed. Please check your credentials and try again.');
      }
    } catch (error) {
      console.error('Login error:', error);
      if (error instanceof Error) {
        setError(`Login failed: ${error.message}`);
      } else {
        setError('An unexpected error occurred during login. Please try again.');
      }
    }
  };

  return (
    <Container maxWidth="xs">
      <Box sx={{ mt: 8, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Paper elevation={3} sx={{ p: 4, borderRadius: 2, width: '100%', background: 'linear-gradient(135deg, #ffffff 0%, #f0f4f8 100%)' }}>
          <Typography variant="h4" component="h1" gutterBottom align="center" sx={{ color: '#3a7bd5' }}>
            Login
          </Typography>
          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
          <form onSubmit={handleSubmit}>
            <TextField
              label="Email"
              type="email"
              fullWidth
              margin="normal"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
            />
            <TextField
              label="Password"
              type="password"
              fullWidth
              margin="normal"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
            />
            <Button 
              type="submit" 
              variant="contained" 
              fullWidth 
              sx={{ 
                mt: 2, 
                mb: 2, 
                background: 'linear-gradient(to right, #3a7bd5, #00d2ff)',
                '&:hover': {
                  background: 'linear-gradient(to right, #3a7bd5, #3a7bd5)',
                },
              }}
            >
              Login
            </Button>
          </form>
          <Typography align="center">
            <Link component={RouterLink} to="/forgot-password" sx={{ color: '#3a7bd5' }}>
              Forgot password?
            </Link>
          </Typography>
          <Typography align="center" sx={{ mt: 2 }}>
            Don't have an account? <Link component={RouterLink} to="/register" sx={{ color: '#3a7bd5' }}>Register</Link>
          </Typography>
        </Paper>
      </Box>
    </Container>
  );
};

export default Login;